import React from 'react'
import styled from 'styled-components'

const Root = styled.div`
  display: flex;
  width: 100%;
  align-items: ${({ $alignItems }) => $alignItems};
  justify-content: ${({ $justify }) => $justify};
  gap: ${({ $gap }) => (typeof $gap === 'number' ? `${$gap}px` : $gap)};
`

export function Line({ children, gap = 8, alignItems = 'center', justify = 'flex-start', ...props }) {
  return (
    <Root $gap={gap} $alignItems={alignItems} $justify={justify} {...props}>
      {children}
    </Root>
  )
}
